module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/costume_type_both_costume@3x-743f68545665b6038b0625fac8a0a07b.webp";